import { accessToken } from "services/accessToken";
import { getToken } from './authActions';

export const sendToken = (endpoint, data) => async (dispatch) => {
    dispatch({ type: 'TOKEN_LOADING' });
    try {
        const result = await accessToken(endpoint, data);
        localStorage.setItem("AccessToken", data.accessToken);

        dispatch({ type: 'TOKEN_SUCCESS', payload: result });

        await dispatch(getToken());

    } catch (error) {
        dispatch({ type: 'TOKEN_ERROR', error: error.message});
    }
};
